"use strict";Object.defineProperty(exports, "__esModule", {value: true});


var _VYZTFWCGcjs = require('../__chunks/VYZTFWCG.cjs');
require('../__chunks/PTOCUU2D.cjs');
require('../__chunks/3BSDKDKD.cjs');
require('../__chunks/XMDZRF6Y.cjs');



exports.Role = _VYZTFWCGcjs.Role; exports.useRole = _VYZTFWCGcjs.useRole;
